import { render, staticRenderFns } from "./SendBox.vue?vue&type=template&id=11e3acd6&"
import script from "./SendBox.vue?vue&type=script&lang=js&"
export * from "./SendBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports